// store/modules/itemIncome/actions.js
import ItemIncomeApi from "../../../api/modules/ItemIncomeApi";

const searchIncomes = (_, payload) => {
  return ItemIncomeApi.searchIncomes(payload.context, payload.idClient, payload);
};

const saveIncome = (_, payload) => {
  return ItemIncomeApi.saveIncome(payload.context, payload.payload);
};

const saveIncomeBulk = (_, payload) => {
  return ItemIncomeApi.saveIncomeBulk(payload.context, payload.payload);
};

const cancelIncome = (_, payload) => {
  return ItemIncomeApi.cancelIncome(payload.context, payload.idIncome);
};

export default {
  searchIncomes,
  saveIncome,
  saveIncomeBulk,
  cancelIncome
};



// WEBPACK FOOTER //
// ./src/store/modules/itemIncome/actions.js